// Profil (self-service) feature — query-kulcs gyár. A tényleges hívásokat a route/komponensek a tipizált
// ts-rest kliensen (`api.profile*`) intézik; a kulcsok itt élnek (cache-egységesítés + invalidálás).
// A `@atlas/contracts` a szerződés forrás-igazsága — itt csak kulcs/segéd-logika van (a többi feature mintája).

/** A saját profil (GET /profile) cache-kulcsa. A session (navbar) kulcsa a `['session']` (app-shell). */
export const profileKeys = {
  all: ['profile'] as const,
  /** A gazdag self-profil (GET /profile). */
  detail: () => ['profile'] as const,
  /** A saját személyes adatok (GET /profile/personal — CSAK belső) — a `detail` alá fűzve, így vele együtt frissül. */
  personal: () => ['profile', 'personal'] as const,
  /** A JWKS-token claimjei (navbar név/avatar) — a profil-mentés ezt is invalidálja. */
  session: () => ['session'] as const,
};
